<template>
  <form method="post" action="" enctype="multipart/form-data">
    <input
      :id="$id('file')"
      type="file"
      name="files[]"
      :multiple="multiple"
      @change="$emit('change', $event.target.files)"
    />
    <label :for="$id('file')" class="w-full" :class="{ loading }">
      <template v-if="!loading">
        Choose a file to upload
      </template>
      <template v-else>
        <i class="fal fa-sun fa-spin fa-fw" />
      </template>
    </label>
  </form>
</template>

<script>
export default {
  name: "BdgFileUploader",
  props: {
    multiple: Boolean,
    loading: Boolean
  }
};
</script>
